/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/

import { css } from 'styled-components';

import { UiBreakpoint } from '../../../../utils/constants';

const WelcomePageStyles = css`
	.pec-study-layout-content {
		padding-bottom: 100px;
	}

	@media (max-width: ${UiBreakpoint}px) {
	}
`;

export default WelcomePageStyles;
